import LiquidButton from '@components/LiquidButton/LiquidButton.vue'
import { authComputed } from '@state/helpers'
import isTabletMixin from '@mixins/isTablet'

export default {
  name: 'NavBar',
  components: {
    'liquid-button-component': LiquidButton,
  },
  mixins: [isTabletMixin],
  data() {
    return {
      pageHeading: '',
      activeIndex: null,
      isEditor: false,
      stepIndex: 0,
      isProfile: false,
      isBilling: false,
      defaultMenuStyles: {
        bgColor: '#F6F7F6',
        textColor: '#666666',
        activeColor: '#18171a',
      },
      primaryMenuStyles: {
        bgColor: '#0f2815',
        textColor: '#ffffff',
        activeColor: '#C8E85E',
      },
      editorMenuStyles: {
        bgColor: '#132935',
        textColor: '#ffffff',
        activeColor: '#C8E85E',
      },
    }
  },
  computed: {
    ...authComputed,
    allowSetPassword() {
      return this.$store.getters['users/allowSetPassword']
    },
    hasPaidSubscription() {
      return this.$store.getters['users/hasPaidSubscription']
    },
    getEditorRoute() {
      switch (this.stepIndex) {
        case 2:
          return { name: 'editor', params: { id: this.$route.params.id } }
        case 3:
          return { name: 'setup:display', params: { id: this.$route.params.id } }
        default:
          return { name: 'dashboard', params: { id: this.$route.params.id } }
      }
    },
    dynamicMenuStyles() {
      return this.isProfile
        ? this.primaryMenuStyles
        : this.isEditor
        ? this.editorMenuStyles
        : this.defaultMenuStyles
    },
    userProfileName() {
      let profileName = this.currentUser.username
      if (this.currentUser.firstName && this.currentUser.lastName) {
        profileName = this.currentUser.firstName + ' ' + this.currentUser.lastName
      }

      return profileName
    },
  },
  watch: {
    $route: {
      // Trigger handler immediately when rendered
      immediate: true,
      handler(to) {
        // react to route changes...
        this.pageHeading = to.meta.pageHeading
        this.activeIndex = to.path
        this.checkIfEditor(to.meta)
        this.checkIfProfile(to.meta)
        this.checkIfBilling(to.meta)
      },
    },
  },
  mounted() {
    if (this.$route.path === '/') {
      this.activeIndex = window.location.pathname
    } else {
      // if exists remove '/' at end of path
      this.activeIndex = this.$route.path.replace(/\/$/, '')
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      // console.log(key, keyPath);
    },
    checkIfBilling(meta) {
      this.isBilling = meta.isBilling || false
    },
    checkIfEditor(meta) {
      this.isEditor = meta.isEditor || false
      this.stepIndex = meta.stepIndex || 0
    },
    checkIfProfile(meta) {
      this.isProfile = meta.isProfile || false
    },
  },
}
